// extracted by mini-css-extract-plugin
export default {"pass":"Passcard_pass__DR5P1","grid":"Passcard_grid__aao4t"};